import React, { useState } from "react";
import classnames from "classnames";
import completeTick from "../../assets/adornments/form-complete-tick.svg";
import cssClass from "./ClinicBookingForm.module.scss";

const ClinicBookingForm = ({ isFree = true }) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    setSubmitted(true);
    e.preventDefault();
  };

  return (
    <div className={cssClass.container}>
      <div
        className={classnames(cssClass.formContainer, {
          [cssClass.submitted]: submitted,
        })}
        aria-hidden={submitted}
      >
        <div className={cssClass.titleContainer}>
          <h3>Request first appointment</h3>
          {isFree && <p>Free</p>}
        </div>
        <form className={cssClass.bookingForm} onSubmit={handleSubmit}>
          <div className={cssClass.inputGroup}>
            <label htmlFor="name">Your Name</label>
            <input required id="name" placeholder="First and last name" />
          </div>
          <div className={cssClass.inputGroup}>
            <label htmlFor="email">Email</label>
            <input
              required
              type="email"
              id="email"
              placeholder="youremail@email.com"
            />
          </div>
          <div className={cssClass.inputGroup}>
            <label htmlFor="phone-number">Phone Number</label>
            <span id="phone-number-hint">Please include your contry code</span>
            <div className={cssClass.phoneNumberInputContainer}>
              <input
                className={cssClass.countryCodeInput}
                required
                placeholder="+45"
                // TODO: add "+" as a pseudoelement to `value`?
              />
              <input
                className={cssClass.phoneNumberInput}
                required
                type="tel"
                aria-describedby="phone-number-hint"
                id="phone-number"
                placeholder="0000000"
              />
            </div>
          </div>
          <div className={cssClass.checkboxGroup}>
            <input id="data-protection-checkbox" type="checkbox" />
            <label htmlFor="data-protection-checkbox">
              I hereby accept the terms of the data protection clause
            </label>
          </div>
          <input type="submit" />
        </form>
      </div>

      <div
        className={classnames(cssClass.completeViewContainer, {
          [cssClass.submitted]: submitted,
        })}
        aria-hidden={!submitted}
      >
        <img src={completeTick} alt="tick" />
        <h3>Your request has been sent</h3>
        <p>We’ll get back to you in the next 24h to confirm a slot.</p>
      </div>
    </div>
  );
};

export default ClinicBookingForm;
